import styled from 'styled-components';

export const OptionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

interface OptionCardProps {
  selected?: boolean;
}
export const OptionCard = styled.div<OptionCardProps>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 16px;
  background: #fff;
  border: 1px solid ${(props) => (props.selected ? '#5768ff' : '#e5e5e5')};
  border-radius: 16px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);

  cursor: pointer;
  transition: all 0.2s ease;

  &.answered {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:hover {
    border-color: ${(props) => (props.selected ? '#5768FF' : '#d0d0d0')};
    background: ${(props) => (props.selected ? '#f8f9ff' : '#fbfbfb')};
  }

  &.is-correct {
    min-width: 46px;
    background: #d1fae5;
    border: 1px solid #10b981;
  }

  &.is-incorrect {
    min-width: 46px;
    background: #fee2e2;
    border: 1px solid #ef4444;
  }

  &.is-correct-answer {
    min-width: 46px;
    background: #f0fdf4;
    border: 1px solid #10b981;
  }

  @media (max-width: 768px) {
    padding: 16px 18px;
  }
`;

export const OptionIcon = styled.div<{ selected?: boolean }>`
  min-width: 32px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: ${(props) => (props.selected ? '#5768FF' : '#f0f0f0')};
  color: ${(props) => (props.selected ? '#fff' : '#666')};
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  transition: all 0.2s ease;
  position: relative;
  gap: 2px;
  padding: 0 8px;

  &.is-correct {
    background: #10b981;
    color: #fff;
  }

  &.is-incorrect {
    background: #ef4444;
    color: #fff;
  }

  &.is-correct-answer {
    background: #10b981;
    color: #fff;
  }
`;

export const OptionText = styled.div`
  flex: 1;
  margin: 0;
  color: #101010;
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  vertical-align: middle;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;
